function ApiError(error, dataErrors = []) {
  this.error = error;
  this.errors = dataErrors;
  this.stack = new Error().stack;
  this.name = 'ApiError';
}

ApiError.prototype = Object.create(Error.prototype);
ApiError.prototype.constructor = ApiError;

export default ApiError;
